/**
 * @generated SignedSource<<c1782fc8574f8b0d1ff21da0d803e22f>>
 * @relayHash 98e82b8b0fdc767642295ee5e7ce49ad
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 98e82b8b0fdc767642295ee5e7ce49ad

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ccnId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tableType"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ccnId",
        "variableName": "ccnId"
      },
      {
        "kind": "Variable",
        "name": "offerType",
        "variableName": "offerType"
      },
      {
        "kind": "Variable",
        "name": "tableType",
        "variableName": "tableType"
      }
    ],
    "kind": "ScalarField",
    "name": "tableParametrage",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Ccn",
    "kind": "LinkedField",
    "name": "ccns",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shortTitle",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TableParametrageQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TableParametrageQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "98e82b8b0fdc767642295ee5e7ce49ad",
    "metadata": {},
    "name": "TableParametrageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "a6204e646166fcc946fd7766eeb4c898";

export default node;
